<template>
    <div>
        <div style="flex:1; display:flex; flex-direction: column;">
            <div style="padding:15px;">
                <img :src="require('@/assets/images/coach_register/coach_regi_screen_x_btn.png')" style="width:14px; height:14px;" @click="() => { $GlobalStore.closeLastModal() }">
            </div>
            <div style="flex:1;display:grid; place-items: center;">
                <div style="display:flex; justify-content: center; flex-direction: column;">
                    <div style="height:250px; display:grid; place-items: center;">
                        <img :src="require('@/assets/images/coach_register/coach_regi_kick.jpg')" style="width:224px; transition: transform 0.8s ease-in-out;" :style="{ transform: is_loaded ? '' : ' translateY(100px) scale(0.2)' }">
                    </div>
                    <div style="padding:30px 0px; transition: all 0.8s ease-in-out;" class="explanation_ani" :class="[is_explanation_show ? '' : 'active']">
                        <template v-if="step === 0 && textStep === 0">
                            <div class="title">반갑습니다 축구 전문가님!</div>
                            <!-- <div class="line_text" style="margin-top:20px;">안녕하세요 회원님,</div>
                            <div class="line_text">회원님 같은 분을 만나길 기다리고 있었습니다.</div>
                            <div class="line_text">사커하우에 잘 찾아오셨습니다.</div> -->
                        </template>
                        <template v-if="step === 0 && textStep === 1">
                            <div class="title">지금부터 간단하게 <br>전문가 인증을 도와드릴게요!</div>
                        </template>
                        <!-- <template v-if="step === 1">
                            <div class="line_text" style="margin-top:20px;">회원님이 만약 프로리그에서 활동했거나 축구대회에</div>
                            <div class="line_text">출전한 경험이 있는 축구선수 출신이라면 </div>
                            <div class="line_text">사커하우에서 코치로 활동할 수 있습니다.</div>
                        </template>
                        <template v-if="step === 2">
                            <div class="line_text" style="margin-top:20px;">지금 활동하시는 지역에서 많은 회원들이 전문적인</div>
                            <div class="line_text">수업을 진행하고 싶어합니다. 다양한 회원들을 모아</div>
                            <div class="line_text">수업을 진행하고 많은 수익을 창출할 수 있습니다.</div>
                        </template> -->
                    </div>

                    <div style="display:grid; place-items: center; margin-top:20px; height:32px;">
                        <transition name="fade">
                            <img v-if="isShowBtn" :src="require('@/assets/images/coach_register/coach_regi_next.png')" style="width:32px; height:32px;" @click="goNext(step)">
                        </transition>
                    </div>

                    <div style="height:100px;"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { COACH_DOC_COMPLETE } from "./CoachDocComplete";
import {MEMBER_TYPE, JOIN_CHAT_TYPE} from '@/Constants'

export default {
    name: "CoachRegisterExplanation",
    props: {
        step: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            is_loaded: false,
            isShowBtn: false,
            is_explanation_show: false,
            textStep: 0
        }
    },
    methods: {
        goNext(step) {
            if (step === 0) {
                // this.$GlobalStore.addModal('CoachRegisterExplanation', { step: 1 });
                if (this.textStep === 1) {
                    this.openChatCoachAndAdmin()
                    return
                }
                this.textStep++
            } else if (step === 1) {
                this.$GlobalStore.addModal('CoachRegisterExplanation', { step: 2 });
            } else if (step === 2) {
                this.$GlobalStore.addModal('CoachDocComplete', { type: COACH_DOC_COMPLETE.EXPLANATION });
            }
        },
        async openChatCoachAndAdmin(){
            await this.$Axios.showPersonalChat(this.$Util.getAdminMemberIdx(), MEMBER_TYPE.USER, JOIN_CHAT_TYPE.CHAT_FOR_COACH_CERT);
        }
    },
    mounted() {
        if (this.step === 0) {
            setTimeout(() => {
                this.is_loaded = true;
            }, 500)
            setTimeout(() => {
                this.isShowBtn = true;
            }, 3000)
            setTimeout(() => {
                this.is_explanation_show = true;
            }, 1500)
        }
    },
    created() {
        if (this.step !== 0) {
            this.is_loaded = true;
            this.isShowBtn = true;
            this.is_explanation_show = true;
        }
    }
}
</script>

<style scoped>
.title {
    text-align: center;
    color: #210F03;
    font-size: 30px;
    font-weight: 700;
    line-height: 36px;
}

.line_text {
    color: #210F03;
    text-align: center;
    font-size: 16px;
    font-weight: 500;
    margin-top: 5px;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.explanation_ani {}

.explanation_ani.active {
    transform: translateY(100px);
    opacity: 0;
}
</style>